import React, { Component } from "react";

const ReportHeader = ({ title, subtitle, page }) => {
	require("./Ensa.css");
	return (
		<div className="card-header">
			<div className="pnl-page">
				<div className="card-page">{page}</div>
				<div className="label-link">https://eduprime.co.id</div>
			</div>

			<div className="flex-header">
				<div className="wrap-header-content">
					<div className="title-header2">{title}</div>
					<div className="label-subTit">{subtitle}</div>
				</div>
				<div className="pnl-right-header">
					<img src="/assets/image/logo_eduprime.png" width={"150px"} alt="" />
				</div>
			</div>
		</div>
	);
}

export default ReportHeader;
